import {Duration, Instant, ZonedDateTime} from "js-joda";

function timeOpenDuration(openedAt, closedAt, clock) {
    if (!openedAt) {
        return null;
    }
    const openTimestamp = ZonedDateTime.parse(openedAt).toInstant();
    const closeTimestamp = closedAt ? ZonedDateTime.parse(closedAt).toInstant() : Instant.now(clock);

    return Duration.between(openTimestamp, closeTimestamp);
}

function timeOpenString(openDuration) {
    if (!openDuration) {
        return "";
    }

    const mins = openDuration.toMinutes();
    if (mins === 0) {
        return "<1 min";
    }
    if (mins < 60) {
        return `${mins} min${mins === 1 ? "" : "s"}`;
    }

    const hours = openDuration.toHours();
    if (hours < 24) {
        return `${hours} hour${hours === 1 ? "" : "s"}`;
    }

    const days = openDuration.toDays();
    return `${days} day${days === 1 ? "" : "s"}`;
}

export function timeBetween(start, end, clock) {
    const openDuration = timeOpenDuration(start, end, clock);
    return timeOpenString(openDuration);
}

export function addTimeOpen(idea, clock) {
    const openDuration = timeOpenDuration(idea.openTimestamp, idea.closeTimestamp, clock);
    if (!openDuration) {
        return idea;
    }

    return {
        ...idea,
        timeOpen: timeOpenString(openDuration),
        timeOpenMillis: openDuration.toMillis()
    };
}

export function addTimeOpenInPeriod(idea, clock) {
    const openDuration = timeOpenDuration(idea.performanceStart, idea.performanceEnd, clock);
    if (!openDuration) {
        return idea;
    }
    return {
        ...idea,
        timeOpenInPeriod: timeOpenString(openDuration),
        timeOpenInPeriodMillis: openDuration.toMillis()
    };
}
